import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ClassificationReason,
  ClassificationReasonIcon,
  RenderWhen
} from "../../../../../components";
import {
  CLASSIFICATION_LABELS_AND_ICONS,
  isClassificationReasonExtractedFile,
  isClassificationReasonGoodwareOverride
} from "../../../../../components/ClassificationSource";
import useParanoidMode from "../../../../paranoid-mode/hooks/useParanoidMode";
import { riskToleranceLevelConfig } from "../../../../paranoid-mode/riskToleranceLevelConfig";

import { SECTIONS } from "../../../consts";
import { pathToSS } from "../../../util";
import { SUMMARY_FILE_CLASSIFICATIONS_ID } from "../../summary/SummaryFileClassifications";

type Props = {
  classificationSource: number;
  classificationReason: string;
  classificationReasonStyle: string;
  hasFileClassification: boolean;
  threatStatus: string;
};

const getTitle = (source: number, reason: string) => {
  if (isClassificationReasonExtractedFile(source)) {
    return "Extracted Files";
  }
  if (isClassificationReasonGoodwareOverride(source)) {
    return "Goodware Override";
  }
  return reason;
};

const ClassificationReasonCard = ({
  classificationReason,
  classificationReasonStyle,
  classificationSource,
  hasFileClassification,
  threatStatus
}: Props) => {
  const { hash = "", sourceId = "" } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { paranoidModeConfig } = useParanoidMode();

  const title = getTitle(classificationSource, classificationReason);

  const handleSectionClick = () => {
    if (!hasFileClassification) return;
    const path = pathToSS(
      hash,
      sourceId,
      SECTIONS.FILE_ANALYSIS.HOW_WE_CAUGHT_THIS
    );
    navigate(`${path}${search}`, {
      state: { scrollTo: SUMMARY_FILE_CLASSIFICATIONS_ID }
    });
  };

  const { label, icon } =
    CLASSIFICATION_LABELS_AND_ICONS[classificationSource] || {};

  return (
    <ClassificationReason
      icon={
        <RenderWhen condition={threatStatus !== "unknown"}>
          <ClassificationReasonIcon
            source={classificationSource}
            style={classificationReasonStyle}
          />
        </RenderWhen>
      }
      label={
        <RenderWhen condition={!!paranoidModeConfig} fallback={label}>
          {icon === "paranoid"
            ? `${label} ${riskToleranceLevelConfig[
                paranoidModeConfig?.level || 0
              ].id.capitalize()}`
            : label}
        </RenderWhen>
      }
      title={title}
      showHelp={icon === "paranoid"}
      onClick={handleSectionClick}
    />
  );
};

export default ClassificationReasonCard;
